<div mat-dialog-title class="dialog-title p-3 pr-5 clearfix">
  <h5>Hazards & Risks</h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>

  <form class="form-inline my-auto my-xl-0 float-xl-right" (ngSubmit)="dataSource.getData(true)">
    <button mat-raised-button class="mr-2 mr-xl-3 my-1" type="button" (click)="onChangeSelectedSite()" [matBadge]="dataSource.site_id > 0 ? '1' : 'All'">
      <mat-icon>location_on</mat-icon> Select {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}
    </button>

    <input
      class="form-control mr-2 my-1"
      type="search"
      [(ngModel)]="dataSource.search"
      name="search"
      placeholder="Search"
      aria-label="Search" />

    <button mat-raised-button color="secondary" class="mr-2 mr-xl-3 my-1" type="submit">
      <mat-icon>search</mat-icon> Search
    </button>

    <button mat-raised-button class="mr-2 my-1" (click)="onClearSelected()" type="button">
      Clear Selected
    </button>
  </form>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    matSortActive="name"
    matSortDirection="asc"
    matSortDisableClear>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox
          (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? dataSource.selection.toggle(row.id) : null"
          [checked]="dataSource.selection.isSelected(row.id)">
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Hazard/Risk</th>
      <td mat-cell *matCellDef="let element">
        <b>{{ element.name }}</b> <br />
        <small>{{ element.description | ellipsis: ['60'] }}</small>
      </td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let element">{{ element.status }}</td>
    </ng-container>

    <!-- IRA Column -->
    <ng-container matColumnDef="ira">
      <th mat-header-cell *matHeaderCellDef>Initial <br />Risk Assessment</th>
      <td mat-cell *matCellDef="let element">
        <span [class]="utils.getSiteRiskStatusTextColor(utils.getRiskAssessmentText(element.ira_likelihood, element.ira_severity))">
          {{ utils.getRiskAssessmentText(element.ira_likelihood, element.ira_severity) }}
        </span>
      </td>
    </ng-container>

    <!-- RRA Column -->
    <ng-container matColumnDef="rra">
      <th mat-header-cell *matHeaderCellDef>Residual <br />Risk Assessment</th>
      <td mat-cell *matCellDef="let element">
        <span [class]="utils.getSiteRiskStatusTextColor(utils.getRiskAssessmentText(element.rra_likelihood, element.rra_severity))">
          {{ utils.getRiskAssessmentText(element.rra_likelihood, element.rra_severity ) }}
        </span>
      </td>
    </ng-container>

    <!-- Site Column -->
    <ng-container matColumnDef="site">
      <th mat-header-cell *matHeaderCellDef>{{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} Name</th>
      <td mat-cell *matCellDef="let element">
        {{ (getHazardSite(element)?.name || '') | ellipsis: ['60'] }}

        <small *ngIf="!element.site && element.asset?.site" class="text-muted ml-1">
          via Asset
        </small>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-end px-3 py-1">
  <mat-paginator
    class="my-2 ml-1 mr-2"
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>

  <button
    class="my-2 ml-1 mr-2"
    mat-raised-button
    color="primary"
    type="button"
    (click)="onSaveAndClose()"
    [disabled]="!data['multiple'] && !dataSource.selection.hasValue()">
    Select & Close
  </button>
</mat-dialog-actions>

